import React, { Fragment, useState } from 'react';
import { productImg } from '../../../lib/constants';
import { useFetch } from '../../../lib/useFetch';
import { Container, Grid, Table, Card, Button, Page, Dimmer } from "tabler-react";
import PaginationBar from '../../../components/pagination';
import SearchInput from '../../../components/searchInput';

const Stores = ({ openMainModal }) => {
  const [page, setPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const [reload, toggleReload] = useState(false);

  const onSearch = (term) => {
    setSearchQuery(term);
    setPage(1);
  };

  const searchParam = searchQuery ? `&search=${encodeURIComponent(searchQuery)}` : '';
  const { data, loading, totalCount } = useFetch(`stores?page=${page}${searchParam}`, reload);

  return (
    <Fragment>
      <Container>
        <Page.Header>
          <Page.Title>Stores</Page.Title>
        </Page.Header>

        <Grid>
          <Grid.Row>
            <Card>
              <Dimmer active={loading} loader={loading}>
                <Card.Header>
                  <Card.Options>
                    <SearchInput value={searchQuery} onSubmit={onSearch} />

                    <Button
                      className="ml-2"
                      icon="plus"
                      color="primary"
                      size="md"
                      onClick={() =>
                        openMainModal('store-create', null, () =>
                          toggleReload((r) => !r)
                        )
                      }
                    >
                      Create Store
                    </Button>
                  </Card.Options>
                </Card.Header>

                {!loading && (!data || data.length < 1) ? (
                  <div className="alert alert-primary m-0">
                    No Stores to show!
                  </div>
                ) : (
                  <div className="table-responsive-wrapper">
                    <Table hasOutline striped>
                      <Table.Header>
                        {['Logo', 'Store Name', 'Category', 'URL'].map((head, i) => (
                          <Table.ColHeader key={`tableHeader-${i}`}>
                            {head}
                          </Table.ColHeader>
                        ))}
                        <Table.ColHeader>Actions</Table.ColHeader>
                      </Table.Header>

                      <Table.Body>
                        {data && data.map(({ image, name, categoryId, url, _id }) => (
                          <Table.Row key={_id}>
                            <Table.Col>
                              <img
                                src={image || productImg}
                                alt="store"
                                className="h-8"
                                width="50"
                                height="50"
                              />
                            </Table.Col>

                            <Table.Col>
                              {name || '—'}
                            </Table.Col>

                            <Table.Col>
                              {categoryId?.name || 'No Category'}
                            </Table.Col>

                            <Table.Col>
                              {url ? (
                                <a href={url} target="_blank" rel="noreferrer">
                                  Visit
                                </a>
                              ) : (
                                '—'
                              )}
                            </Table.Col>

                            <Table.Col>
                              <div className="actions-wrap">
                                <Button
                                  outline
                                  color="secondary"
                                  size="sm"
                                  onClick={() =>
                                    openMainModal('store-edit', _id, () =>
                                      toggleReload((r) => !r)
                                    )
                                  }
                                >
                                  Edit
                                </Button>

                                <Button
                                  outline
                                  color="danger"
                                  className="ml-2"
                                  size="sm"
                                  onClick={() =>
                                    openMainModal('stores--delete', _id, () =>
                                      toggleReload((r) => !r)
                                    )
                                  }
                                >
                                  Delete
                                </Button>
                              </div>
                            </Table.Col>
                          </Table.Row>
                        ))}
                      </Table.Body>
                    </Table>
                  </div>
                )}

                {data && data.length > 0 && (
                  <PaginationBar
                    page={page}
                    totalCount={totalCount}
                    setPage={setPage}
                  />
                )}
              </Dimmer>
            </Card>
          </Grid.Row>
        </Grid>
      </Container>
    </Fragment>
  );
};

export default Stores;